// extracted by mini-css-extract-plugin
export var standaloneTable = "_eq-0";
export var standaloneTableWithBodyFill = "_eq-1";
export var withExtraHeader = "_eq-2";